import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { MultiplePartnerDetailType } from 'types/LegalPartner';

export const useGetMultiplePartnerDetails = (id: string[], enabled: boolean) => {
  return useQuery<MultiplePartnerDetailType[], AxiosError>({
    queryKey: ['useGetMultiplePartnerDetails', id],
    queryFn: () => {
      const list = id.filter((item) => item !== 'other');
      return contactNoteDialogService.getMultiplePartnerDetails(list);
    },
    enabled: enabled && id.length > 0,
  });
};
